import { AppLink } from "@/components/AppLink";
import { Details } from "@/components/IAndI/Details";
import { IAndIDistribution } from "@/components/IAndI/DistributionBar";
import { cn } from "@/lib/utils";

interface PopUpProps {
	iAndI: Dryp.IAndISummary;
	// Set false when composing inside another popup that already shows the
	// structure title (e.g. on the general map).
	showTitle?: boolean;
	// Optional "Period: …" label shown above the breakdown.
	timePeriodLabel?: string;
}

export const PopUp: React.FC<PopUpProps> = ({ iAndI, showTitle = true, timePeriodLabel }) => {
	return (
		<div className={cn("px-2.5 py-2 space-y-2", !showTitle && "pt-1.5 border-t")}>
			{showTitle && (
				<AppLink
					to="Dashboard.Structures.Structure"
					params={{ id: iAndI.structure.id }}
					className="text-sm font-semibold text-foreground leading-tight hover:underline block"
				>
					{iAndI.structure.name}
				</AppLink>
			)}
			{timePeriodLabel && (
				<div className="flex items-center justify-between">
					<span className="text-[10px] text-muted-foreground">Period: {timePeriodLabel}</span>
				</div>
			)}
			{iAndI.parts && <Details breakdown={iAndI.parts} period={iAndI.period} />}
			<IAndIDistribution summary={iAndI} />
		</div>
	);
};
